<template lang="pug">
ul.navbar-menu
    li.visible-xs-block.select-shop-li
        select-shop
    li
        router-link(:data-toggle='dataToggle', :href='href', :to="{name: 'UserInfo'}")
            | Профиль
    li
        router-link(:data-toggle='dataToggle', :href='href', :to="{name: 'TariffPlan'}")
            | Тарифный план и оплата
    li
        a(:data-toggle='dataToggle', :href='href', @click.prevent="switchThemeMode")
            | Переключиться на {{ isDarkMode ? 'светлую' : 'темную' }} тему
    li
        a(:data-toggle='dataToggle', :href='href', @click.prevent='logout')  Выйти 
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import SelectShop from './SelectShop';

export default {
    name: 'Navbar',
    components: {
        'select-shop': SelectShop
    },
    props: {
        dataToggle: {
            default: 'blahblah'
        },
        href: {
            default: 'someothertest'
        }
    },
    computed: mapState({
        openedMenuItem: 'openedMenuItem',
        isDarkMode: state => state.localStorage.isDarkMode
    }),
    methods: {
        ...mapActions(['logout']),
        ...mapMutations(['switchThemeMode'])
    }
};
</script>

<style>
.navbar-menu li a.router-link-active {
    background-color: #337ab7;
}
.navbar-menu.nav.navbar-right li {
    padding: 0;
}
.navbar-menu.nav.navbar-right li a {
    padding: 15px 25px 15px 25px;
}
.select-shop-li {
    text-align: center;
    padding: 2px 25px 2px 25px!important;
}
.select-shop-li .select-shop {
    margin-top: 0;
    width: 100%;
}
.select-shop-li .select-shop ul {
    top: -34px;
    text-align: center;
}
.select-shop-li .select-shop a {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue